import { OnlyData } from '@/utils/subtypes'
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'

export default interface IBagReferences {
    gltf: GLTF
    bag: THREE.Group
    parent: THREE.Group
    metal: THREE.SkinnedMesh
    transparent: THREE.SkinnedMesh
    body: THREE.SkinnedMesh
    edge: THREE.SkinnedMesh
    pocket:  THREE.Mesh
    side:  THREE.Mesh
    fronts: THREE.SkinnedMesh[]
    ribbon:  THREE.Mesh
    covertacks: THREE.SkinnedMesh[]
    back: THREE.SkinnedMesh
}

export class BagReferences implements IBagReferences {
    gltf!: GLTF
    bag!: THREE.Group
    parent!: THREE.Group
    metal!: THREE.SkinnedMesh
    transparent!: THREE.SkinnedMesh
    body!: THREE.SkinnedMesh
    edge!: THREE.SkinnedMesh
    pocket!: THREE.Mesh
    side!: THREE.Mesh
    fronts!: THREE.SkinnedMesh[]
    ribbon!: THREE.Mesh
    covertacks!: THREE.SkinnedMesh[]
    back!: THREE.SkinnedMesh

    constructor(data: OnlyData<BagReferences>) {
        Object.assign(this, data);
    }

}

